import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 2rem;
`;

export const DateInfo = styled.p`
  font-size: 0.8em;
  font-weight: bold;
  color: gray;

  text-align: left;
  margin-bottom: 20px;

  // text-transform: uppercase;
`;

export const CardsWrapper = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Card = styled.div`
  height: 140px;
  
  flex: 1;

  padding: 1rem 1.5rem;
  font-weight: bold;
  color: #595959;

  border-radius: 0.5rem;
  box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.12);

  p {
    white-space: normal;
    text-transform: uppercase;
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;


  margin-top: 0.5rem;

  p {
    font-size: 1.5em;
    color: ${(props) => props.theme.background.darkest};
  }
`;

export const LabelsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  width: 100%;

  div p {
    font-size: 0.6em;
  }

  div {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0rem;
      left: -0.7rem;

      width: 10px;
      height: 10px;
      background: #24ff24;
    }
  }
`;

export const ChartWrapper = styled.div`
  width: 100px;
  height: 100px;

  canvas {
    width: 100px;
  }
`;
